import { focusPreviousRegion } from 'owa-accessibility-landmarks';
import {
    IPageService,
    IPageTabsService,
    IConfigService,
    EventService,
    PageServiceEventMap,
    IBackStackService,
    FrameInfo,
    IPagesFullTrustService,
    IAppButtonService,
} from '@metaos/hub-sdk';

const noOp = () => {}; /* Safely tags what is yet to be implemented. */

export default class PageService extends EventService<PageServiceEventMap> implements IPageService {
    public appButtonService?: IAppButtonService;
    public tabsService?: IPageTabsService;
    public configService?: IConfigService;
    public backStackService?: IBackStackService;
    public fullTrustService?: IPagesFullTrustService;

    public returnFocus(navigateForward?: boolean): Promise<void> {
        focusPreviousRegion();
        return Promise.resolve();
    }

    public setCurrentFrame(frameInfo: FrameInfo): Promise<void> {
        noOp();
        return Promise.resolve();
    }

    public withAppButtonService(appButtonServiceInput?: IAppButtonService): IPageService {
        noOp();
        return this;
    }

    public withTabsService(tabsServiceInput?: IPageTabsService): IPageService {
        noOp();
        return this;
    }

    public withConfigService(configServiceInput?: IConfigService): IPageService {
        noOp();
        return this;
    }

    public withBackStackService(backStackServiceInput?: IBackStackService): IPageService {
        noOp();
        return this;
    }

    public withFullTrustService(fullTrustServiceInput?: IPagesFullTrustService): IPageService {
        noOp();
        return this;
    }
}
